import useTranslation from 'next-translate/useTranslation'
import { Divider } from 'rsuite'

import { getProductUseCases } from '../../../lib/product'
import { Product } from '../../../utils/types/Product'
import useIsOnMobile from '../../../services/useIsOnMobile'
import { ScreenSize } from '../../../utils/constants'

import styles from '../../../styles/UseCases.module.less'

const UseCases: React.FC<{ product: Product }> = ({ product }) => {
  const { t } = useTranslation('products')
  const useCaseData = getProductUseCases(product)
  const isOnMobile = useIsOnMobile(ScreenSize.md)

  return (
    <>
      {useCaseData?.length
        ? (
          <ul className={styles['use-cases']}>
            {useCaseData.map(
              (el) => (
                <li
                  key={el['attribute.id']}
                  className={styles['use-case-single']}
                  data-testid="use-case-single"
                >
                  {el['attribute.label']}
                </li>
              ),
            )}
          </ul>
        )
        : (
          <>
            {isOnMobile && <Divider />}
            {t('Use Cases are not defined')}
          </>
        )}
    </>
  )
}

export default UseCases
